/** Notas de saída cuja situação a listagem e o documento consultam. Espelha ListarSituacaoNotaFiscalSaidaRequest (OrquestradorVendas). */
export class ListarSituacaoNotaFiscalSaidaRequest {
  listaIdNFeSaida: number[] = [];
}
